let Config = {
    maxXSmScreen: 768,
    minSmScreen: 769,
    maxSmScreen: 991,
    minMScreen: 992,
    maxMScreen: 1199,
    minLScreen: 1200
};

export default Config;